module.exports = __webpack_public_path__ + "img/madeInGermany@2x.b4ac3d3.webp";